import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Navbar, Nav, Form, InputGroup, Dropdown } from "react-bootstrap";

import {
  AlertCircle,
  Bell,
  BellOff,
  Home,
  MessageCircle,
  UserPlus,
  Search,
  Feather,
  Paperclip,
} from "react-feather";

import useSidebar from "../../hooks/useSidebar";

import NavbarDropdown from "./NavbarDropdown";
import NavbarDropdownItem from "./NavbarDropdownItem";
import NavbarUser from "./NavbarUser";
import { useNavigate } from "react-router";
import useAppSelector from "../../hooks/useAppSelector";
import { selectCurrentUser } from "../../redux/slices/authSlice";
import SidebarNav from "../sidebar/SidebarNav";
import { SidebarItemsType } from "../../types/sidebar";

import img1 from '../../assets/img/1.svg';
import img2 from '../../assets/img/2.svg';


interface SidebarProps {
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  admin: boolean;
  open?: boolean;

}

export interface NavItemType {
  href: string;
  icon: React.FC<any>;
  title: string;
}


const NavbarComponent = ({ items, admin }: { items: NavItemType[], admin: boolean }) => {
  const { t } = useTranslation();
  const { isOpen, setIsOpen } = useSidebar();
  const navigate = useNavigate();
  const user = useAppSelector(selectCurrentUser);

  const handlePage = (item: any) => {
    navigate(item);
  }

  return (
    <Navbar variant="light" expand className="navbar-bg">
      <Nav className="navbar-align">
        <a className="sidebar-brand" href="/">
          <img src={img1} alt="MEFSC" />
          {/* <span style={{ color: "#ffc700", fontSize: 14 }}>MANUFACTURING EXCELLENCE FORUM</span>
          <br />
          <span style={{ fontSize: 14 }}>SUNSHINE COAST</span>
          <br />
          <br />
          <small>(Beta - v2.0)</small> */}
        </a>
      </Nav>
      <Nav className="navbar-align">
        {items.map((item, i) => (
          <Button key={i} className="me-2 nav-item" onClick={() => handlePage(item?.href)}>
            {item?.title}
          </Button>
        ))}
        {user ? (
          <NavbarUser />
        ) : (
          <Button onClick={() => navigate('/login')}>
            LOGIN
          </Button>
        )
        }
      </Nav>
      <Nav className="navbar-align">
        <a className="sidebar-brand" href="/">
          <img src={img2} alt="partners" />
        </a>
      </Nav>
    </Navbar >
  );
};

export default NavbarComponent;
